
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.814 22.803"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.515 3.442h-12.46V1.3a1.3 1.3 0 00-1.3-1.3H1.3A1.3 1.3 0 000 1.3v20.2a1.3 1.3 0 001.3 1.3h23.215a1.3 1.3 0 001.3-1.3V4.741a1.3 1.3 0 00-1.3-1.299zm.439 18.058a.439.439 0 01-.439.439H1.3a.439.439 0 01-.44-.439V8.175h24.094zM.86 7.314V1.3A.439.439 0 011.3.86h9.457a.439.439 0 01.439.439v3h13.32a.439.439 0 01.439.439v2.573z","fill":"#fff"}})])
          )
        }
      }
    